import {createContext} from "react";

export const musicContext = createContext(null);